import React from 'react';
import PropTypes from 'prop-types';

const Sidebar = ({ children }) => <div className="cl-blog-content__sidebar">{children}</div>;

const BlogContent = ({ children }) => {
  const sidebar = React.Children.toArray(children).filter((item) => item?.type === Sidebar);
  const main = React.Children.toArray(children).filter((item) => item?.type !== Sidebar);
  return (
    <div className="cl-blog-content">
      <div className="cl-blog-content__main">{main}</div>
      {sidebar}
    </div>
  );
};

BlogContent.Sidebar = Sidebar;

Sidebar.propTypes = {
  children: PropTypes.node,
};

BlogContent.propTypes = {
  children: PropTypes.node,
};

export default BlogContent;
